import { ImagesType } from '@/modules/types/generic/image/ImagesType'
import type { DefectSummaryType } from 'Modules/types/pages/reportDashboard/summaryTypes'

const summarizeDefects = (data: Array<DefectSummaryType>): Array<ImagesType> => {
  const summary = {}

  data.forEach((item) => {
    const { defectType, defectSurfaceArea } = item

    // Initialize with infinity so annotations without size do not throw off calcs
    if (!summary[defectType]) {
      summary[defectType] = {
        type: defectType,
        count: 0,
        min: Infinity,
        max: -Infinity,
        sum: 0,
      }
    }

    summary[defectType].count++
    // Only process valid defect_surface_area values (non-null)
    if (defectSurfaceArea !== null) {
      const validDefectSurfaceArea = defectSurfaceArea === -1 ? 0 : defectSurfaceArea
      summary[defectType].sum += validDefectSurfaceArea
      summary[defectType].min = Math.min(summary[defectType].min, validDefectSurfaceArea)
      summary[defectType].max = Math.max(summary[defectType].max, validDefectSurfaceArea)
    }
  })

  // If keys have no sizes related to them return 0 rather than infinity
  // Also check if were getting improper -1 values and correct n/a
  Object.keys(summary).forEach((defectType) => {
      const defectStats = summary[defectType]

      if (defectStats.min === Infinity || defectStats.min === -1) {
        defectStats.min = 0 // Or 'n/a' if preferred for -1 specifically and min can be string
      } else {
        defectStats.min = parseFloat(defectStats.min.toFixed(2))
      }

      if (defectStats.max === -Infinity || defectStats.max === -1) {
        defectStats.max = 0 // Or 'n/a' if preferred for -1 specifically and max can be string
      } else {
        defectStats.max = parseFloat(defectStats.max.toFixed(2))
      }

      if (defectStats.count === 0) {
        defectStats.sum = 0
        defectStats.avg = 0
      } else {
        defectStats.sum = parseFloat(defectStats.sum.toFixed(2))
        // Calculate and format average area
        defectStats.avg = parseFloat((defectStats.sum / defectStats.count).toFixed(2))
      }
  })
    // Convert the summary object to an array of rows for easier table rendering
    return Object.values(summary)
  }

export { summarizeDefects }
